<div class="container">
  <section class="inner-container">
    <main>
    <div class="products" style="background: white; ">
      <div class="content-container">
        <div class="text-center">
          <h1 class="title-default intro-title">Update Business Account</h1>
          <hr class="yellow-line-large">


        </div>
        <div class="inner">
          <div class="flex-wrap scroll_checklist">
                <form (change)="notSaved()" name="biz-acc-form" id="biz-acc-form" data-k2-validation="true" novalidate class="col-sm-8 general-form" style="padding: 0">
                  <h5 class="title-form">Once you have your Business Current Account number, please update it below and click Submit. </h5>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group">
                        <input type="text" maxlength="12" name="mbCurAccNo" id="mbCurAccNo" [(ngModel)]="business_account_no" placeholder="" class="custom-input" required data-rules="required|curAccNo" data-error-mes="This field is required|Account No. must be a 12-digit number starting with 0 or 5" onkeypress="return (event.charCode > 47 && event.charCode < 58)">
                            <label>Maybank Current Account No.*</label>
                        
                      </div>
                      <label> 12-digit company current account number </label>
                    </div>
                  </div>

                  <div class="row" [hidden]="!m2upayShow">
                    <div class="col-xs-11 col-md-5">
                        <div class="group">
                            <input type="text" maxlength="12" name="collection_account" id="collection_account" [(ngModel)]="account_number_collection"  placeholder="" class="custom-input" required data-rules="required|curAccNo" data-error-mes="This field is required|Account No. must be a 12-digit number starting with 0 or 5" onkeypress="return (event.charCode > 47 && event.charCode < 58)" >
                            <label>Collection Account Number*</label>
                        </div>
                        
                    </div>
                    <div class="col-xs-1 col-md-1">
                        <div class="tooltip">
                          <i class="icons icon-info">
                            <div class="layer-tooltip">
                              <p>Account for you to receive payment from your customer.</p>
                            </div>
                          </i>
                        </div>
                    </div>
                    <div class="col-xs-11 col-md-5">
                        <div class="group">
                            <input type="text" maxlength="12" name="charging_account" id="charging_account" [(ngModel)]="account_number_charging"  placeholder="" class="custom-input" required data-rules="required|curAccNo" data-error-mes="This field is required|Account No. must be a 12-digit number starting with 0 or 5" onkeypress="return (event.charCode > 47 && event.charCode < 58)" >
                            <label>Charging Account Number*</label>
                        </div>
                    </div>
                    <div class="col-xs-1 col-md-1">
                        <div class="tooltip">
                          <i class="icons icon-info">
                            <div class="layer-tooltip">
                              <p>Account for Bank to deduct the transaction fee charges.</p>
                            </div>
                          </i>
                        </div>
                    </div>
                </div>
                  
                  <div class="row" id="save_checklist">
                    <div class="col-md-3">
                      

                    </div>
                    <div class="col-md-6">
                    </div>         
                    <div class="col-md-3">
                      <button type="button" class="btn btn-primary btn-block" (click)="submit(true)">Submit</button>
                      <button [hidden]="true" #clrSubmit type="submit">Submit</button>
                    </div>   

                    
                  </div>
                </form>
          </div>
        </div>
      </div>
    </div>
    </main>
  </section>
</div>